import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import React from "react";
import {
  closeDialog,
  openDialog,
} from "../../../components/dialog/dialogSlice";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import AppDialog, {
  DialogCloseButton,
} from "../../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import IconButton from "../../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import FormTextField from "../../../components/formFields/FormTextField";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import { ISectorCity } from "../../city/cityModel";
import { getItineraryByID } from "../../itinerary/services/itineary.services";
import FormRichTextField from "../../../components/formFields/FormRichTextField";
import { ImageViewField } from "../../../components/formFields/ImageViewField";
import defaultitineraryimage from "../../../assets/Images/default-itinerary-image.jpg";

const B2BTourItineraryArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const [deleteIndex, setDeleteIndex] = React.useState(-1);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const SectorCityList = useAppSelector((state) => state.city.SectorCityList);
  const ItineraryList = useAppSelector((state) => state.itineary.ItinearyList);

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("b2bTourItineraryDeleteDialog"));
    setDeleteIndex(index);
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      setDeleteIndex(-1);
    },
    [fieldArrayRenderProps, dispatch],
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        DayNo: (fieldArrayRenderProps.value?.length || 0) + 1,
        PlaceID: null,
        ItinaryID: null,
        Description: "",
        ItineraryImage: defaultitineraryimage,
      },
    });
  }, [fieldArrayRenderProps]);

  const filterItineary = (PlaceID: number) => {
    if (PlaceID) {
      const result = ItineraryList.filter((itineary: any) => {
        return itineary.CityID === PlaceID;
      });
      return result.map((itineary) => {
        return {
          value: itineary.ID,
          label: itineary.ItineraryTitle,
        };
      });
    }
  };

  const handleChangeItinerary = async (e: any, index: number) => {
    if (e?.value) {
      const res: any = await dispatch(getItineraryByID(e?.value));
      if (res.meta?.requestStatus === "fulfilled") {
        fieldArrayRenderProps.formRenderProps.onChange(
          `Itinary.${index}.Description`,
          {
            value: `${res.payload.Description}`,
          },
        );
        fieldArrayRenderProps.formRenderProps.onChange(
          `Itinary.${index}.ItineraryImage`,
          {
            value: res.payload.ItineraryImage || defaultitineraryimage,
          },
        );
      }
    } else {
      fieldArrayRenderProps.formRenderProps.onChange(
        `Itinary.${index}.Description`,
        {
          value: "<p></p>",
        },
      );
      fieldArrayRenderProps.formRenderProps.onChange(
        `Itinary.${index}.ItineraryImage`,
        {
          value: defaultitineraryimage,
        },
      );
    }
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {(!fieldArrayRenderProps.value || fieldArrayRenderProps.value.length === 0) ? null : null}
      <GridLayoutItem style={{ marginBottom: 10 }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
          className="fw-bold"
        >
          Add Tour Itinerary Day
        </Button>
      </GridLayoutItem>
      {dialogName === "b2bTourItineraryDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Tour Itinerary"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this day?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "10px"
                }}
              >
                <DialogCloseButton themeColor="dark" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(deleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map((ItinaryItem: any, index: number) => (
          <GridLayoutItem key={index}>
            <Card className="border-0">
              <GridLayout
                gap={{ rows: 10, cols: 10 }}
                style={{ marginRight: 30 }}
                cols={[
                  { width: "15%" },
                  { width: "25%" },
                  { width: "45%" },
                  { width: "15%" },
                ]}
              >
                <GridLayoutItem>
                  <Field
                    name={`Itinary.${index}.DayNo`}
                    label="Day No"
                    placeholder="Day"
                    type="number"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`Itinary.${index}.PlaceID`}
                    label="City"
                    placeholder="Select City"
                    component={FormSelectionField}
                    options={SectorCityList?.map((city: ISectorCity) => {
                      return {
                        value: city?.ID,
                        label: city?.CityName,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`Itinary.${index}.ItinaryID`}
                    label={"Itinerary"}
                    placeholder="Select ItineraryTemplate"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={
                      ItineraryList && filterItineary(ItinaryItem.PlaceID)
                    }
                    onChange={(e: any) => {
                      handleChangeItinerary(e, index);
                    }}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    paddingBottom: "5px"
                  }}
                >
                  <IconButton
                    onClick={() => handleOpenDeleteDialog(index)}
                    themeColor={"error"}
                    fillMode={"flat"}
                    type="button"
                    icon={MdDelete}
                    iconStyle={{ fontSize: "24px" }}
                  />
                </GridLayoutItem>

                <GridLayoutItem colSpan={3}>
                  <Field
                    name={`Itinary.${index}.Description`}
                    label="Description"
                    placeholder="Itinerary Description"
                    component={FormRichTextField}
                    validator={requiredValidator}
                    astrike={true}
                    minHeight={150}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`Itinary.${index}.ItineraryImage`}
                    label="Image"
                    component={ImageViewField}
                  />
                </GridLayoutItem>
              </GridLayout>
              <hr className="my-3" />
            </Card>
          </GridLayoutItem>
        ))}

      {fieldArrayRenderProps.value && fieldArrayRenderProps.value.length > 0 && (
        <GridLayoutItem>
          <Button
            fillMode={"outline"}
            themeColor={"primary"}
            onClick={pushElementInarray}
            type="button"
            className="fw-bold"
          >
            Add Another Day
          </Button>
        </GridLayoutItem>
      )}
    </GridLayout>
  );
};

export default B2BTourItineraryArray;
